import { render, staticRenderFns } from "./CopyDataMenuItem.vue?vue&type=template&id=8c76e012"
import script from "./CopyDataMenuItem.vue?vue&type=script&lang=ts"
export * from "./CopyDataMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports